import {
  Component,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EventEmitter } from "@angular/core";
import { roleMSDTO } from "app/models/roleMS.model";
import { RoleMSService } from "app/services/utils/roleMS.service";

export interface GrantRole {
  id: number;
  role_id: number;
  user_id: number;
}

export interface NewGrantRole {
  role_id: number;
  user_id: number;
}

@Component({
  selector: "app-change-users-role-form",
  templateUrl: "changeUsersRoleForm.component.html",
})
export class ChangeUsersRoleForm implements OnInit, OnChanges {
  grantRolesLoyalty: any[];
  grantRolesPromotion: any[];
  grantRolesCommon: any[];
  grantRolesCustomer: any[];

  grantRoleLoyalty: GrantRole | NewGrantRole;
  grantRolePromotion: GrantRole | NewGrantRole;
  grantRoleCommon: GrantRole | NewGrantRole;
  grantRoleCustomer: GrantRole | NewGrantRole;

  invalidSubmit = false;

  @Input() currentRoleUser: roleMSDTO;
  @Output() onRolesUpdate: EventEmitter<any> = new EventEmitter<any>();

  changeRoleForm: FormGroup;

  constructor(
    private grantRolesService: RoleMSService,
    private formBuilder: FormBuilder
  ) {
    this.changeRoleForm = this.formBuilder.group({
      role: this.formBuilder.group({
        loyalty_role: [null, Validators.required],
        promo_role: [null, Validators.required],
        common_role: [null, Validators.required],
        customer_role: [null, Validators.required],
      }),
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    this.getAllGrantRoles();
    this.getUserGrantRole();
  }

  getAllGrantRoles() {
    this.grantRolesService.list("/koncentro-loyalty").subscribe((res) => {
      this.grantRolesLoyalty = res.data.map((role) => ({
        value: role.id,
        label: role.description,
      }));
      this.grantRolesLoyalty = [
        { value: null, label: "" },
        ...this.grantRolesLoyalty,
      ];
    });

    this.grantRolesService.list("/koncentro-promo").subscribe((res) => {
      this.grantRolesPromotion = res.data.map((role) => ({
        value: role.id,
        label: role.description,
      }));
      this.grantRolesPromotion = [
        { value: null, label: "" },
        ...this.grantRolesPromotion,
      ];
    });

    this.grantRolesService.list("/koncentro-common").subscribe((res) => {
      this.grantRolesCommon = res.data.map((role) => ({
        value: role.id,
        label: role.description,
      }));
      this.grantRolesCommon = [
        { value: null, label: "" },
        ...this.grantRolesCommon,
      ];
    });

    this.grantRolesService.list("/koncentro-customers").subscribe((res) => {
      this.grantRolesCustomer = res.data.map((role) => ({
        value: role.id,
        label: role.description,
      }));
      this.grantRolesCustomer = [
        { value: null, label: "" },
        ...this.grantRolesCustomer,
      ];
    });
  }

  getUserGrantRole() {
    this.grantRolesService
      .getRolesForUser("/koncentro-loyalty", this.currentRoleUser.id)
      .subscribe((res) => {
        const { id, role_id, user_id } = res[0];

        this.grantRoleLoyalty = {
          id,
          role_id,
          user_id,
        };

        if (this.currentRoleUser) {
          this.changeRoleForm.patchValue({
            role: {
              loyalty_role: this.grantRoleLoyalty.role_id,
            },
          });
        }
      });

    this.grantRolesService
      .getRolesForUser("koncentro-promo", this.currentRoleUser.id)
      .subscribe((res) => {
        const { id, role_id, user_id } = res[0];
        this.grantRolePromotion = { id, role_id, user_id };

        if (this.currentRoleUser) {
          this.changeRoleForm.patchValue({
            role: {
              promo_role: this.grantRolePromotion.role_id,
            },
          });
        }
      });

    this.grantRolesService
      .getRolesForUser("koncentro-common", this.currentRoleUser.id)
      .subscribe((res) => {
        const { id, role_id, user_id } = res[0];

        this.grantRoleCommon = {
          id,
          role_id,
          user_id,
        };

        if (this.currentRoleUser) {
          this.changeRoleForm.patchValue({
            role: {
              common_role: this.grantRoleCommon.role_id,
            },
          });
        }
      });

    this.grantRolesService
      .getRolesForUser("koncentro-customers", this.currentRoleUser.id)
      .subscribe((res) => {
        const { id, role_id, user_id } = res[0];

        this.grantRoleCustomer = {
          id,
          role_id,
          user_id,
        };

        if (this.currentRoleUser) {
          this.changeRoleForm.patchValue({
            role: {
              customer_role: this.grantRoleCustomer.role_id,
            },
          });
        }
      });
  }

  saveOrUpdate(event) {

    const updatedLoyaltyRoleId =
      this.changeRoleForm.get("role.loyalty_role").value;
    const updatedPromoRoleId = this.changeRoleForm.get("role.promo_role").value;
    const updatedCommonRoleId =
      this.changeRoleForm.get("role.common_role").value;
    const updatedCustomerRoleId =
      this.changeRoleForm.get("role.customer_role").value;

    const allUpdatedRoles = {};

    const getCurrentRoleId = (grantRole: GrantRole | NewGrantRole): number => {
      return grantRole ? grantRole.role_id : null;
    };

    const currentLoyaltyRoleId = getCurrentRoleId(this.grantRoleLoyalty);
    const isLoyaltyChanged = updatedLoyaltyRoleId !== currentLoyaltyRoleId;

    if (isLoyaltyChanged) {
      if (this.grantRoleLoyalty && "id" in this.grantRoleLoyalty) {
        this.grantRoleLoyalty.role_id = updatedLoyaltyRoleId;
      }
      else {
        this.grantRoleLoyalty = {
          role_id: updatedLoyaltyRoleId,
          user_id: this.currentRoleUser.id,
        };
      }
      allUpdatedRoles["loyalty"] = this.grantRoleLoyalty;
    }

    const currentPromotionRoleId = getCurrentRoleId(this.grantRolePromotion);
    const isPromotionChanged = updatedPromoRoleId !== currentPromotionRoleId;

    if (isPromotionChanged) {
      if (this.grantRolePromotion && "id" in this.grantRolePromotion) {
        this.grantRolePromotion.role_id = updatedPromoRoleId;
      } else {
        this.grantRolePromotion = {
          role_id: updatedPromoRoleId,
          user_id: this.currentRoleUser.id,
        };
      }
      allUpdatedRoles["promo"] = this.grantRolePromotion;
    }

    const currentCommonRoleId = getCurrentRoleId(this.grantRoleCommon);
    const isCommonChanged = updatedCommonRoleId !== currentCommonRoleId;

    if (isCommonChanged) {
      if (this.grantRoleCommon && "id" in this.grantRoleCommon) {
        this.grantRoleCommon.role_id = updatedCommonRoleId;
      } else {
        this.grantRoleCommon = {
          role_id: updatedCommonRoleId,
          user_id: this.currentRoleUser.id,
        };
      }
      allUpdatedRoles["common"] = this.grantRoleCommon;
    }

    const currentCustomerRoleId = getCurrentRoleId(this.grantRoleCustomer);
    const isCustomerChanged = updatedCustomerRoleId !== currentCustomerRoleId;

    if (isCustomerChanged) {
      if (this.grantRoleCustomer && "id" in this.grantRoleCustomer) {
        this.grantRoleCustomer.role_id = updatedCustomerRoleId;
      } else {
        this.grantRoleCustomer = {
          role_id: updatedCustomerRoleId,
          user_id: this.currentRoleUser.id,
        };
      }
      allUpdatedRoles["customers"] = this.grantRoleCustomer;
    }

    console.log(allUpdatedRoles);

    this.onRolesUpdate.emit(allUpdatedRoles);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/users/changeUsersRoleForm.component.ts